import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicCheckbox } from 'core/components';
import _ from 'lodash';
import ReactTooltip from 'react-tooltip';

const SelectSkuQuantityTemplate = ({
	t,
	viewStore: { handleItemQuantityChange, handleItemQuantityOnInputChange, handleFocusChange },
	additionalDisableCheck,
	onePerBoxInputDisable,
	productsForSelection,
	warningMessage,
	title,
}) => {
	return (
		<section>
			<div className="box--primary box--sml spc--bottom--sml">
				<div className="box__header">
					<h2 className="box__header__title">{t(title)}</h2>
					{warningMessage && (
						<div>
							<p className="type--color--warning spc--bottom--sml">{t(warningMessage)}</p>{' '}
						</div>
					)}
				</div>
				<table className="table table--secondary">
					<colgroup>
						<col width="30" />
						<col />
						<col />
					</colgroup>
					<thead>
						<tr>
							<th></th>
							<th>{t('SELECTSKUQUANTITYVIEW.SKU')}</th>
							<th>{t('SELECTSKUQUANTITYVIEW.QUANTITY')}</th>
						</tr>
					</thead>

					<tbody>
						{_.map(productsForSelection, item => {
							return (
								<tr key={item.id} className={`${item.disabled ? 'disabled' : ''}`}>
									<td className="align--v--middle">
										<BaasicCheckbox
											checked={item.isChecked}
											id={item.id}
											disabled={item.disabled || additionalDisableCheck}
											onChangeCallback={event => handleItemQuantityChange(item, event.currentTarget.checked, event)}
											className={`input--check ${item.isPartiallyChecked ? 'input--check--partially' : ''}`}
										/>
									</td>
									<td>
										<div className="flex--primary" htmlFor={item.id}>
											<label className="spc--right--nano type--color--dark">{item.sku}</label>
											<span className="type--color--grey-3">({item.quantity})</span>
											{item.product.onePerBox && (
												<i
													data-tip={t('SELECTSKUQUANTITYVIEW.ONEPERBOX')}
													className="spc--left--tny fas fa-exclamation-circle"
												/>
											)}
											<ReactTooltip />
										</div>
									</td>
									<td>
										<div className="input--stepper">
											<button
												type={'button'}
												disabled={item.disabled || additionalDisableCheck}
												onClick={() => handleItemQuantityChange(item, false, null)}
												className="input--stepper--aside"
											>
												<span className="fa fa-minus"></span>
											</button>
											<input
												className="input--stepper--main"
												value={item.checkedQuantity}
												onFocus={() => handleFocusChange(item, false)}
												onBlur={() => handleFocusChange(item, true)}
												onChange={event => handleItemQuantityOnInputChange(item, parseInt(event.target.value))}
												disabled={
													(onePerBoxInputDisable ? item.product.onePerBox : false) ||
													item.disabled ||
													additionalDisableCheck
												}
											/>
											<button
												type={'button'}
												disabled={item.disabled || additionalDisableCheck}
												onClick={() => handleItemQuantityChange(item, true, null)}
												className="input--stepper--aside"
											>
												<span className="fa fa-plus"></span>
											</button>
										</div>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		</section>
	);
};

export default defaultTemplate(SelectSkuQuantityTemplate);
